<div class="side-wrapper">
  <div class="header">
    <h2 class="title">Serverkonfiguration</h2>
    <hr />
  </div>
  <form class="content" [formGroup]="deletionPeriodForm" (ngSubmit)="saveDeletionPeriod()">
    <div class="part-wrapper">
      <h3 class="info-title">Löschfrist einstellen</h3>
      <p class="sub-info">Hier können Sie die löschfrist für inaktive Chats einstellen.</p>
    </div>
    <div class="part-wrapper">
      <h3 class="info-title">Löschfrist für inaktive Chats</h3>
      <p class="sub-info">Chats werden automatisch gelöscht, wenn sie solange inaktiv waren</p>
      <div class="reminder-container">
        <input
          formControlName="deletionPeriod"
          [attr.data-testid]="testIds.deleteperiodInput"
          class="reminder-time-input"
          type="number"
          min="0" />
        <span class="reminder-time-label">Monate nach Inaktivität</span>
      </div>
    </div>
    <div class="deactivate-wrapper">
      <div>
        <h3 class="info-title">Löschen deaktivieren</h3>
        <p class="sub-info">automatische Chatlöschung aktivieren/deaktivieren</p>
      </div>
      <div class="slider-wrapper">
        <app-tooltip-icon
          class="tooltip-deletion"
          [alignTooltip]="'right'"
          [infoText]="
            'wenn das Löschen aktiv ist, werden inaktive Chats nach der Löschfristeinstellung gelöscht. ' +
            'Deaktivieren Sie die Löschung, bleiben Inaktive Chats fristlos bestehen'
          "
          [infoTitle]="deletionPeriodForm.value.isActive ? 'Löschen aktiv' : 'Löschen deaktiviert'"></app-tooltip-icon>
        <p class="sub-info deletion-info">Löschen {{ deletionPeriodForm.value.isActive ? 'aktiv' : 'deaktiviert' }}</p>
        <mat-slide-toggle
          (change)="onSliderChange($event)"
          [formControlName]="'isActive'"
          class="tim-slide-toggle deletion"
          [attr.data-testid]="testIds.deleteperiodSlider"></mat-slide-toggle>
      </div>
    </div>
    <hr />
    <div class="button-wrapper">
      <app-button
        text="Abbrechen"
        type="button"
        [attr.data-testid]="testIds.cancelDeleteperiod"
        (click)="resetForm()"
        (keydown)="$event.stopPropagation()"></app-button>
      <app-button
        text="Speichern"
        [attr.data-testid]="testIds.saveDeleteperiod"
        [isPrimary]="true"
        type="submit"></app-button>
    </div>
  </form>
</div>
